import styled from 'styled-components';
import { Locale } from '../../../../../modules/core/types';

export const Container = styled.div`
  position: relative;

  .panda-input-text {
    padding-left: 40px;
  }
`;

export const ColorButton = styled.button<{ color: string; hasTitle: boolean; locale: Locale }>`
  background-color: ${(props) => props.color || '#FFFFFF'};
  border-radius: 4px;
  height: 24px;
  width: 24px;
  position: absolute;
  z-index: 1;
  top: ${(props) => (props.hasTitle ? '35px' : '8px')};
  left: 8px;

  &:hover {
    cursor: pointer;
  }

  ${(props) =>
    (!props.color ||
      props.color.toLocaleLowerCase() === 'white' ||
      props.color.toLocaleLowerCase() === '#ffffff' ||
      props.color.toLocaleLowerCase() === '#fff') &&
    `border: 2px solid lightgray`}
`;

export const PickerContainer = styled.div<{ hasTitle: boolean }>`
  position: absolute;
  top: ${(props) => (props.hasTitle ? '64px' : '40px')};
  z-index: 999;
`;

export const Mask = styled.div`
  position: fixed;
  top: 0;
  bottom: 0;
  right: 0;
  left: 0;
  z-index: 90;
`;
